import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import analyticsApi from '~/apis/analytics';
import { StatBar } from '~/components/common';
import { IProtectModeResponse } from '~/utils/interface/analytics';

const OutcomeCard = ({
  title,
  succeeded,
  failed,
  successLabel,
  failedLabel,
}: {
  title: string;
  succeeded: number;
  failed: number;
  successLabel: string;
  failedLabel: string;
}) => {
  const total = succeeded + failed || 1;

  return (
    <div className='flex flex-col gap-4 rounded-lg border border-border bg-card p-4 sm:p-6'>
      <h2 className='text-base font-semibold text-foreground'>{title}</h2>
      <StatBar label={successLabel} value={succeeded} total={total} />
      <StatBar label={failedLabel} value={failed} total={total} tone='destructive' />
    </div>
  );
};

const ProtectMode = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<IProtectModeResponse>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    analyticsApi
      .getProtectMode()
      .then((res) => setData(res.data.data))
      .catch(() => setError('pages.protectMode.loadError'))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div>
      <h1 className='text-xl font-semibold text-foreground'>{t('pages.protectMode.title')}</h1>
      <p className='mt-1 text-sm text-muted-foreground'>{t('pages.protectMode.description')}</p>

      {isLoading && <p className='mt-6 text-sm text-muted-foreground'>{t('common.loading')}</p>}
      {error && <p className='mt-6 text-sm text-destructive'>{t(error)}</p>}

      {data && (
        <div className='mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2'>
          <OutcomeCard
            title={t('pages.protectMode.enable')}
            succeeded={data.enable.succeeded}
            failed={data.enable.failed}
            successLabel={t('common.succeeded')}
            failedLabel={t('common.failed')}
          />
          <OutcomeCard
            title={t('pages.protectMode.disable')}
            succeeded={data.disable.succeeded}
            failed={data.disable.failed}
            successLabel={t('common.succeeded')}
            failedLabel={t('common.failed')}
          />
        </div>
      )}
    </div>
  );
};

export default ProtectMode;
